const categoryEn = [
  'Legal Services',
  'Film and TV Industry',
  'Agriculture',
  'Construction',
  'Education',
  'Electronics',
  'Energy',
  'Entertainment',
  'E-Commerce',
  'Financial Services',
  'Healthcare',
  'Hospitality and Food Services',
  'Import/Export Trade and Wholesale',
  'Intellectual Property',
  'Information Technology',
  'Licensing',
  'Machinery/Equipment',
  'Manufacturing',
  'Media and Communications',
  'Mining & Quarrying',
  'Pharmaceutical',
  'Business Services',
  'Real Estate',
  'Retail',
  'Social and Personal Services',
  'Testing and Laboratory',
  'Textiles/Garments',
  'Transportation, Storage and Courier Services',
  'Utilities',
  'Waste Management',
  'Accounting',
  'Banking',
  'Insurance',
  'Non-Profit Organization',
  'Non-Governmental Organization',
  'Testing and Certification',
  'Marketing Services',
  'Other',
];

export default categoryEn;
